export const KeyMapEnum = {
  Alt: 'alt',
  Backquote: 'backquote', // `
  Backslash: 'backslash', // \
  Backspace: 'backspace',
  BracketLeft: 'bracketleft', // [
  BracketRight: 'bracketright', // ]
  Comma: 'comma',
  CommandOrControl: 'commandorcontrol',
  Control: 'control',
  Ctrl: 'ctrl',
  Down: 'down',
  Enter: 'enter',
  Equal: 'equal', // =
  Esc: 'esc',
  Left: 'left',
  LeftClick: 'left-click',
  LeftDoubleClick: 'left-double-click',
  Meta: 'meta', // Command on Mac, Win on Win
  MiddleClick: 'middle-click',
  Minus: 'minus', // -
  Mod: 'mod', // Command on Mac, Ctrl on Win
  Period: 'period', // .
  Plus: 'equal', // +
  QuestionMark: 'slash', // ?
  Quote: 'quote', // '
  Right: 'right',
  RightClick: 'right-click',
  RightDoubleClick: 'right-double-click',
  Semicolon: 'semicolon', // ;
  Shift: 'shift',
  Slash: 'slash', // /
  Space: 'space',
  Tab: 'tab',
  Up: 'up',
} as const;
